import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export function RequireAuth({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    session
  } = useAuth();
  const location = useLocation();
  if (!session) {
    return <Navigate to="/acceso" replace state={{
      from: location.pathname
    }} data-id="element-262" data-mp="2rb55am2dj85" />;
  }
  return <>{children}</>;
}